var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandscapeInActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 25,
    viewBox: "0 0 45 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 5.3125L1 19.6875C1 22.0692 2.93077 24 5.3125 24L39.8125 24C42.1942 24 44.125 22.0692 44.125 19.6875L44.125 5.31249C44.125 2.93077 42.1942 0.999994 39.8125 0.999994L5.3125 0.999996C2.93077 0.999996 0.999999 2.93077 0.999999 5.3125Z",
    stroke: "#667085",
    strokeWidth: 1.61719,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscapeInActiveIcon);
export default __webpack_public_path__ + "static/media/landscapeInActiveIcon.e8263fa4c879ccc699ea1e130495eea8.svg";
export { ForwardRef as ReactComponent };